export type GetTagsResponse = { items: [{ label: string }] };

export const GET_TAGS_ROUTE = 'tags';

export type TagsForAutocomplete = [{ label: string }];
